export abstract class Expression {
    abstract readonly type:
        | "comparison"
        | "logical"
        | "function"
        | "group"
        | "lambda"
        | "in"
        | "not"
        | "property"
        | "literal";

    abstract stringify(): string;

    abstract getKey(): string;
}
